export enum EClientNotificationsEventTypes {
  onCentralNotification = 'onCentralNotification',
  onCentralNotificationContract = 'onCentralNotificationContract',
  onGympassCheckinNotification = 'onGympassCheckinNotification',
  onTotalpassCheckinNotification = 'onTotalpassCheckinNotification',
  onInvoicesZipCreatedNotification = 'onInvoicesZipCreatedNotification',
  onAccessRealTimeOccupancyNotification = 'onAccessRealTimeOccupancyNotification',
  onCompletedConsumptionNotification = 'onCompletedConsumptionNotification',
  onUserPhotoUploadedNotification = 'onUserPhotoUploadedNotification',
  onHotsitePersonCreatedNotification = 'onHotsitePersonCreatedNotification',
  onSubscriptionReceivementNotification = 'onSubscriptionReceivementNotification',
  onReceivementErrorNotification = 'onReceivementErrorNotification',
  onCrmEventNotification = 'onCrmEventNotification',
  onCrmEventProgressNotification = 'onCrmEventProgressNotification',
  onContractNotSentEventProgressNotification = 'onContractNotSentEventProgressNotification',
  onContractPendingEventProgressNotification = 'onContractPendingEventProgressNotification',
  onContractEventNotification = 'onContractEventNotification',
  /**
   * The daily inactivation check (personservice 004 F3): "N alunos foram
   * inativados". Stored in the central, so it arrives live through
   * `onCentralNotificationContract` with this `Origin`. Shown only to who has
   * `InativosVisualizar` (309).
   */
  onInactivationDailyNotification = 'onInactivationDailyNotification',
}